import type { SupportDeskQueueFilter, SupportDeskView } from '../services/supportDeskApi';

export const SUPPORT_DESK_FILTER_PREFS_KEY = 'customer-success.desk.filter-prefs';

export type SupportDeskFilterPreferences = {
  view?: SupportDeskView | string;
  /** Escopo do combo Fila; "all" só vale na sessão/URL, não é persistido. */
  fila?: SupportDeskQueueFilter | string;
  priority?: string;
  teamId?: string;
  sla?: string;
  tag?: string;
  catalogItemId?: string;
  showGuidance?: boolean;
};

const FILTER_PARAM_KEYS = ['view', 'fila', 'priority', 'teamId', 'sla', 'tag', 'catalogItemId'] as const;

export function hasDeskFilterParamsInUrl(searchParams: URLSearchParams): boolean {
  return FILTER_PARAM_KEYS.some((key) => {
    const value = searchParams.get(key);
    return value != null && value !== '';
  });
}

export function loadSupportDeskFilterPreferences(): SupportDeskFilterPreferences | null {
  try {
    const raw = window.localStorage.getItem(SUPPORT_DESK_FILTER_PREFS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SupportDeskFilterPreferences;
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSupportDeskFilterPreferences(prefs: SupportDeskFilterPreferences): void {
  try {
    window.localStorage.setItem(SUPPORT_DESK_FILTER_PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore quota / private mode
  }
}

export function applySupportDeskFilterPreferences(
  searchParams: URLSearchParams,
  prefs: SupportDeskFilterPreferences,
): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  const setOrDelete = (key: string, value?: string): void => {
    if (value) next.set(key, value);
    else next.delete(key);
  };

  if (prefs.view) next.set('view', prefs.view);
  setOrDelete('priority', prefs.priority);
  setOrDelete('teamId', prefs.teamId);
  setOrDelete('sla', prefs.sla);
  setOrDelete('tag', prefs.tag);
  setOrDelete('catalogItemId', prefs.catalogItemId);
  return next;
}
